<div class="full-layout-wrapper">
  <div class="container-fluid">
    <img
      class="xsight-logo-landscape"
      src="{{ 'SOTI-XSight-Horizontal.svg' | xsImage : '/sotixsight/get-resource/assets/images/' }}"
    />
    <img class="xsight-logo-expired" src="/sotixsight/get-resource/assets/images/loading.svg" />
    <p class="session-timeout-header ins-sub-display">{{ 'expired_session_session_timeout' | xsI18n }}</p>
    <p class="session-timeout-message ins-headline-3">
      {{ getExpiredMessage() }}
    </p>
    <button class="xs-btn btn-primary login-button" type="button" (click)="redirectHandler()">
      <span>{{ 'admin_Email_Outbound_Auth_Login' | xsI18n }}</span>
    </button>
  </div>
</div>
